import { ICreateAndUpdateWorkTime } from "../../../types/workTime.interface";
import customAxios from "../../customAxios";
import { CREATE_WORK_TIME } from "../../routes";
// import { PAY_DEBT_BY_ADMIN_PUT } from "../../routes";

const createWorkTime = async (props: ICreateAndUpdateWorkTime) => {
  const body = {
    dayName: props?.dayName,
    startTime: props?.startTime,
    endTime: props?.endTime,
    dayNumber: props?.dayNumber,
    city: props.city,
  };

  try {
    return (await customAxios.post(CREATE_WORK_TIME, body)).data;
  } catch (error: unknown) {
    console.error({ CREATE_WORK_TIME: error });
    return false;
  }
};

export default createWorkTime;
